import { Card } from '@sparemin/blockhead';
import React from 'react';
import AuthNavLink from '../AuthNavLink';
import {
  RESET_PASSWORD_SUCCESS_CARD_TITLE,
  RESET_PASSWORD_SUCCESS_BUTTON_TEXT,
} from './constants';
export interface ResetPasswordSuccessCardProps {}

const ResetPasswordSuccessCard: React.FC<
  ResetPasswordSuccessCardProps
> = () => {
  return (
    <Card
      header={
        <Card.Header
          title={RESET_PASSWORD_SUCCESS_CARD_TITLE}
          subtitle={
            <AuthNavLink appearance="button" to="login" fluid>
              {RESET_PASSWORD_SUCCESS_BUTTON_TEXT}
            </AuthNavLink>
          }
        />
      }
    />
  );
};

export default ResetPasswordSuccessCard;
